// extracted by mini-css-extract-plugin
export default {"schoolInfoTabs":"school-info-tabs_schoolInfoTabs__oIVR9"};